// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__R8qvo","customMug":"Footer_customMug__umbFl","backtosite":"Footer_backtosite__xi9fH"};